import type { WaveRecord } from "@vida/wave-core";

/** Merge status subscription payload without forcing a new object when nothing changed. */
export function mergeWaveStatus(
  prev: WaveRecord | null,
  incoming: WaveRecord,
): WaveRecord | null {
  if (!prev || prev.waveId !== incoming.waveId) return prev;
  if (
    prev.status === incoming.status &&
    prev.title === incoming.title &&
    prev.updatedAt === incoming.updatedAt
  ) {
    return prev;
  }
  return {
    ...prev,
    status: incoming.status,
    title: incoming.title,
    updatedAt: incoming.updatedAt,
  };
}

export function wavePlaybackKey(wave: WaveRecord | null): string | null {
  if (!wave) return null;
  return `${wave.waveId}:${wave.latestSnapshotSeq}:${wave.templateId ?? ""}`;
}
